<div class="flex flex-row">
  <app-toolbar [items]="breadcrumbItems" class="w-100-percent"></app-toolbar>
</div>

<div *ngIf="!showSpinner && !isFailed" class="p-24">
  <div class="mat-headline-5 fs-32 fw-600 m-0">{{solutionDetails?.name}}</div>
  
  <div class="flex flex-col mb-32 pt-32">
    <div class="flex flex-row justify-between justify-start mb-48">
      <div class="flex flex-col mr-104">
        <div *ngIf="solutionDetails?.punchline" class="mat-headline-5 fw-600 mb-16">{{ solutionDetails?.punchline }}</div>
        <div class="mat-body-1 pb-24">{{ solutionDetails?.shortDescription }}</div>
        <div *ngIf="capabilitiesGroups">
          <div *ngFor="let capabilitiesGroup of capabilitiesGroups" class="mat-headline-5 fw-700 mb-14 capabilities-count">
            {{capabilitiesGroup.capabilities.length}} {{capabilitiesGroup.name === CapabilityType.MANDATORY   ?
            ('SOLUTIONS.INCLUDED_CAPABILITIES' | transloco) : ('SOLUTIONS.OPTIONAL_CAPABILITIES' | transloco)}}
          </div>
        </div>
      </div>
      <div class="marketing-media pr-20 cursor-pointer" (click)="openVideo()">
        <app-play-button *ngIf="solutionDetails?.iconHref"></app-play-button>
        <img [src]="solutionDetails?.iconHref">
      </div>
      <ng-template #defaultVideo>
        <iframe width="840" height="350" src="https://www.youtube.com/embed/jUxGj6kbEE8" title="YouTube video player"
          frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen></iframe>
      </ng-template>
    </div>
    <div class="fw-600 mat-subtitle-1 mb-16">{{solutionDetails?.tagline}}</div>
    <div class="flex flex-col justify-start mb-48" [innerHTML]="solutionDetails?.longDescription"></div>
  </div>
    
  <div *ngIf="capabilitiesGroups?.length > 0" class="w-100-percent">
    <div class="flex flex-row pb-48">
      <div class="flex flex-col">
        <div class="mat-headline-5 mb-16">{{solutionDetails?.name}} Capabilities </div>
        <div>
          These are the capabilities that are included in the {{solutionDetails?.name | titlecase}} package for
          {{solutionDetails?.lineOfBusiness[0] | titlecase}}. <br>
        </div>
      </div>
    </div>
    <ng-container *ngFor="let capabilitiesGroup of capabilitiesGroups">
      <div class="mat-headline-5 fw-700 mb-24">
        {{capabilitiesGroup.name === CapabilityType.MANDATORY ? ('SOLUTIONS.INCLUDED_CAPABILITIES' | transloco) :
        ('SOLUTIONS.OPTIONAL_CAPABILITIES' | transloco)}}
        {{capabilitiesGroup.capabilities ? '(' + capabilitiesGroup.capabilities.length + ')' : ''}}
      </div>
      <div>
        <div class="flex flex-row flex-wrap ml--12 mr--12">
          <ng-container *ngFor="let capability of capabilitiesGroup.capabilities">
            <div class="flex pl-12 pr-12 mb-24" [style.max-width.%]="20">
              <app-capability-card  [capability]="capability" class="flex"></app-capability-card>
            </div>
          </ng-container>
        </div>
      </div>
    </ng-container>
  </div>
</div>

<div *ngIf="isFailed" class="flex justify-center top-panel m-24 p-50">
  {{'INSTANCE_LIST.NO_DATA_FOUND' | transloco }}
</div>

<div *ngIf="showSpinner" class="flex spinner-container spinner p-30">
  <mat-spinner diameter="24"
    color="primary"
    mode="indeterminate">
  </mat-spinner>
</div>